<template>
  <div class="feed-filter">
    <span class="font-weight-bold d-none d-sm-inline">Filter with</span>
    <b-button
      v-for="filter in filters"
      :key="filter.type"
      :variant="pressed(filter.type) ? 'secondary' : 'outline-secondary'"
      :class="[pressed(filter.type) ? `btn-feed-${filter.type}` : `btn-outline-feed-${filter.type}`]"
      v-b-tooltip.hover
      :title="filter.tooltip"
      @click="onClick(filter.type)"
    >
    {{filter.text}}
    </b-button>
  </div>
</template>

<script>
import { CATEGORY_TYPE } from '@/helpers/types'

export default {
  name: 'FilterWith',

  model: {
    prop: 'selected',
    event: 'select'
  },

  props: {
    selected: {
      type: Array,
      default: () => Object.values(CATEGORY_TYPE)
    }
  },

  computed: {
    computedSelected() {
      return this.selected.reduce((a, cv) => { a[cv] = true; return a }, {})
    }
  },

  data() {
    return {
      filters: [
        { type: CATEGORY_TYPE.FEEDBACK, text: 'F', tooltip: 'Feedback' },
        { type: CATEGORY_TYPE.KUDO, text: 'K', tooltip: 'Kudo' },
        { type: CATEGORY_TYPE.COACHING, text: 'C', tooltip: 'Coaching' },
        { type: CATEGORY_TYPE.THANKYOU, text: 'TY', tooltip: 'Thank You' },
        { type: CATEGORY_TYPE.WELCOME, text: 'W', tooltip: 'Welcome' }
      ]
    }
  },

  methods: {
    pressed(type) {
      return this.computedSelected[type]
    },

    onClick(type) {
      this.$emit('select', this.pressed(type) ? this.selected.filter(p => p !== type) : [...this.selected, type])
    }
  }
}
</script>
